var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFurniture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "furniture-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "V3",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "furniture-icon",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,0 C24.418278,0 28,3.581722 28,8 L28.0000889,14.1706743 C28.3128427,14.0601428 28.6493978,14 29,14 C30.6568542,14 32,15.3431458 32,17 L32,30 C32,31.1045695 31.1045695,32 30,32 L28,32 C26.8954305,32 26,31.1045695 26,30 L26,28 L6,28 L6,30 C6,31.1045695 5.1045695,32 4,32 L2,32 C0.8954305,32 0,31.1045695 0,30 L0,17 C0,15.3431458 1.34314575,14 3,14 C3.35097203,14 3.6878673,14.0602698 4.00090072,14.1710242 L4,8 C4,3.581722 7.581722,0 12,0 L20,0 Z M3,16 C2.44771525,16 2,16.4477153 2,17 L2,30 L4,30 L4,17 C4,16.4477153 3.55228475,16 3,16 Z M28,30 L30,30 L30,17 C30,16.4477153 29.5522847,16 29,16 C28.4477153,16 28,16.4477153 28,17 L28,30 Z M26,21 L6,21 L6,26 L26,26 L26,21 Z M26,8 C26,4.76160306 23.4344251,2.12242824 20.2249383,2.00413847 L20,2 L12,2 C8.6862915,2 6,4.6862915 6,8 L6,19 L26,19 L26,8 Z",
    id: "Combined-Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFurniture);
export default __webpack_public_path__ + "static/media/furniture.320e0ec0caad10de0e9f5bbc19ac1149.svg";
export { ForwardRef as ReactComponent };